var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.479,
    height: 18.505,
    viewBox: "0 0 18.479 18.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.132,7.552a1.031,1.031,0,0,0-.508-1.743l-4.793-.726h0L9.8.654a1.062,1.062,0,0,0-1.961,0L5.658,5.083h0L.793,5.809A1.031,1.031,0,0,0,.285,7.552L3.77,11.183v.073l-.8,4.865a1.127,1.127,0,0,0,1.6,1.234l4.067-2.324h.073l4.067,2.251a1.127,1.127,0,0,0,1.6-1.234l-.8-4.865V11.11Z",
    transform: "translate(0.531 0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart0);
export default __webpack_public_path__ + "static/media/start-0.536e1d380b4da78d95c2e3aeadc1defc.svg";
export { ForwardRef as ReactComponent };